import * as Rx from "rxjs";
import {ajax, AjaxError, AjaxResponse} from "rxjs/ajax";
import {catchError, map} from "rxjs/operators";
import {environment} from "../../env/environment";
import {Mag2LocalStorage} from "../mag2-local-storage";

const COMMON_HEADERS = {
  "Accept": "application/json",
  "X-Requested-With": "maglive-web-front",
};

const POST_JSON_HEADERS = {
  ...COMMON_HEADERS,
  "Content-Type": "application/json",
};

const xhr = () => {
  const _xhr = new XMLHttpRequest();
  return _xhr;
};

export class ApiClient {

  private static getHeaders(isPost: boolean) {
    const base = isPost ? POST_JSON_HEADERS : COMMON_HEADERS;
    if (environment.production) {
      return base;
    }
    const userId = Mag2LocalStorage.getUserId();
    if (userId === null) {
      return base;
    }
    return {...base, "X-Mag2-User": userId}
  }

  static downloadFileGet<T>(baseURL: string, path: string):Rx.Observable<T> {
    const headers = ApiClient.getHeaders(false);
    delete headers['Accept'];
    
    return ajax({
      method: "GET",
      url: baseURL + path,
      headers: headers,
      crossDomain: true,
      withCredentials: true,
      responseType: "blob"
    }).pipe(
      catchError(ApiClient.toValidationErrorIfNeeded),
      map((r:any) => {
        return r;
      })
    )
  }

  static getJson<T>(baseURL: string, path: string, _headers?: object): Rx.Observable<T> {
    const headers = _headers ? Object.assign(ApiClient.getHeaders(false), _headers) : ApiClient.getHeaders(false);
    return ajax({
      method: "GET",
      url: baseURL + path,
      headers: headers,
      crossDomain: true,
      withCredentials: true,
      responseType: "json",
    }).pipe(
      catchError(ApiClient.toValidationErrorIfNeeded),
      map((r: any) => r.response as T)
    );
  }

  static postJson<T>(baseURL: string, path: string, body: object | null): Rx.Observable<T> {
    return ajax({
      method: "POST",
      url: baseURL + path,
      headers: ApiClient.getHeaders(true),
      body,
      crossDomain: true,
      withCredentials: true,
      responseType: "json",
    }).pipe(
      catchError(ApiClient.toValidationErrorIfNeeded),
      map((r: any) => r.response as T)
    );
  }

  static putJson<T>(baseURL: string, path: string, body: object | null, _headers?: object): Rx.Observable<T> {
    const headers = _headers ? {...ApiClient.getHeaders(true), ..._headers} : ApiClient.getHeaders(true);
    return ajax({
      method: "PUT",
      url: baseURL + path,
      headers: headers,
      body,
      crossDomain: true,
      withCredentials: true,
      responseType: "json",
    }).pipe(
      catchError(ApiClient.toValidationErrorIfNeeded),
      map((r: any) => {
       return r as T
      })
    );
  }

  static deleteJson<T>(baseURL: string, path: string): Rx.Observable<T> {
    return ajax({
      method: "DELETE",
      url: baseURL + path,
      headers: ApiClient.getHeaders(false),
      crossDomain: true,
      withCredentials: true,
      responseType: "json",
    }).pipe(
      catchError(ApiClient.toValidationErrorIfNeeded),
      map((r: any) => r.response as T)
    );
  }

  static postFile<T>(baseURL: string, path: string, body: any): Rx.Observable<T> {
    return new Rx.Observable((observer) => {
      const XHR = xhr();
      XHR.onreadystatechange = function () {
        if (XHR.readyState == 4) {
          if (XHR.status == 200) {
            observer.next(JSON.parse(XHR.response));
          } else {
            observer.error(XHR.response);
          }
        }
      };

      XHR.open('POST', baseURL + path);

      const headers = ApiClient.getHeaders(false);
      Object.keys(headers).forEach(function (key) {
        XHR.setRequestHeader(key, headers[key]);
      });

      XHR.withCredentials = true;
      XHR.send(body);
    });
  }

  static putJsonFetch(baseURL: string, path: string, body: object) {
    const headers = ApiClient.getHeaders(true)
    const newHeaders = new Headers()
    Object.keys(headers).forEach((key) => {
      newHeaders.append(key, headers[key])
    });
    return fetch(baseURL + path, {
      method: "put",
      body: JSON.stringify(body),
      headers: newHeaders,
      credentials: "include",
      mode: "cors",
      keepalive: true
    })
  }


  static getJsonWithHeader<T>(baseURL: string, path: string, _headers?: object): Rx.Observable<T> {
    const headers = _headers ? Object.assign(ApiClient.getHeaders(false), _headers) : ApiClient.getHeaders(false);
    return ajax({
      // createXHR: xhr, // これいるだろうか？
      method: "GET",
      url: baseURL + path,
      headers: headers,
      crossDomain: true,
      withCredentials: true,
      responseType: "json",
      // async: false // これいるだろうか？
    }).pipe(
      catchError(ApiClient.toValidationErrorIfNeeded),
      map((r: any) => r as any)
    );
  }

  private static toValidationErrorIfNeeded(error: AjaxError): Rx.Observable<AjaxResponse> {
    return Rx.throwError((error.xhr.status / 100) == 4 && Array.isArray(error.xhr.response.errors) ? error.xhr.response.errors : error)
  }
}
